import React, { createContext, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ec from "@/i18n/ec.json";
import en from "@/i18n/en.json";

const dictionaries = { ec, en };
const LanguageContext = createContext({
  lang: "ec",
  t: (k) => k,
  switchTo: () => {},
  prefix: "/ec",
});

function getFromDict(dict, path) {
  const parts = path.split(".");
  let cur = dict;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

export function detectLang(pathname) {
  if (pathname.startsWith("/en")) return "en";
  return "ec";
}

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = detectLang(location.pathname);

  const value = useMemo(() => {
    const dict = dictionaries[lang];
    const t = (key, fallback) => {
      const value = getFromDict(dict, key);
      if (value === undefined || value === null) return fallback ?? key;
      return value;
    };
    const switchTo = (nextLang) => {
      if (nextLang === lang) return;
      const currentPath = location.pathname;
      let rest = "";
      if (currentPath.startsWith("/ec")) rest = currentPath.slice(3);
      else if (currentPath.startsWith("/en")) rest = currentPath.slice(3);
      const nextPath = `/${nextLang}${rest || ""}`;
      // Mark language switch so ScrollToTop can skip
      window.__isLanguageSwitch = true;
      navigate(nextPath + location.search + location.hash);
    };
    const prefix = `/${lang}`;
    return { lang, t, switchTo, prefix };
  }, [lang, location.pathname, location.search, location.hash, navigate]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
